import React, { useContext, useEffect, useState } from "react";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import Only2Product from './Only2Product';
import {responsive, doubleproductlistData1, doubleproductlistData2} from '../Only2ProductCarousal/data'
import './CarousalOnly2Product.css'
import { useCart } from '../AddToCart/CartContext';

import { DataContext } from "../ProductCarousal1/DataProvider";
import { useSelector } from "react-redux";
import Skeleton from '@mui/material/Skeleton';
import { Link, NavLink } from "react-router-dom";
import { motion } from 'framer-motion'; // Import Framer Motion

export default function CarousalOnly2Product() {

  const {loading, loadingMore, loadMoreOurCollection } = useContext(DataContext);
  
const {ourCollection}= useSelector(
  (state) => state.ourCollection
  );


 // Track whether the data has been loaded
 const [isDataLoaded, setIsDataLoaded] = useState(false);
  useEffect(() => {
    // Check if all collections have data and set the isDataLoaded flag
    if (
      ourCollection.length > 0
    ) {
      setIsDataLoaded(true);
    }
  }, [ourCollection]);


  
  // Effect to automatically load more products when reaching the bottom of the page (optional)
    useEffect(() => {
      const observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            loadMoreOurCollection();
          }
        },
        { threshold: 1.0 }
      );
  
      const bottomOurCollection = document.getElementById("ourCollection-bottom");
  
      if (bottomOurCollection) observer.observe(bottomOurCollection);
  
      return () => {
        if (bottomOurCollection) observer.unobserve(bottomOurCollection);
      };
    }, [loading, loadingMore]);

  const { addToCart} = useCart();

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 1024 },
      items: 2,
      slidesToSlide: 2,
    },
    desktop: {
      breakpoint: { max: 1024, min: 800 },
      items: 2,
      slidesToSlide: 2,
    },
    tablet: {
      breakpoint: { max: 800, min: 464 },
      items: 2,
      slidesToSlide: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1,
    }
  };

    // const doubleproductlist1 = doubleproductlistData1.map((item) => (
    const doubleproductlist1 = ourCollection.map((item) => (
      <motion.div
    key={item.id}
    initial={{ opacity: 0, y: 20 }} // Initial animation state
    whileInView={{ opacity: 1, y: 0 }} // Animate when in view
    viewport={{ once: false }} // Animate only once
    transition={{ duration: 0.5 }} // Animation duration
  >
        <Only2Product
          key={item.id}
          id={item.id}
          name={item.name}
          title={item.title}
          imageUrl={item.imageUrl}
          price={item.price}
          discountPrice={item.discountPrice}
          description={item.description}
          addToCart={addToCart}
          quantity={item.quantity}
        />
        </motion.div>
        
      ));

      // const doubleproductlist2 = doubleproductlistData2.map((item) => (
      //   <Only2Product
      //     key={item.id}
      //     id={item.id}
      //     name={item.name}
      //     imageUrl={item.imageUrl}
      //     price={item.price}
      //     description={item.description}
      //     addToCart={addToCart}
      //     quantity={item.quantity}
          
      //   />
      // ));


  return (
    <>
      <div className='our-collection-container'>
          <h3 style={{textAlign:'center'}}>ᖳᖰ Feal the Sound Earbuds</h3>
          <NavLink to="/our_collection" className='view_all_our_collection_link'>View All</NavLink>
        {/* {loading ? ( */}
        {loading && !isDataLoaded ? (
          // <p>Loading...</p>
          <Carousel responsive={responsive} keyBoardControl={true}>
            {Array.from({ length: 5 }).map((_, index) => (
              <Skeleton key={index} variant="rectangular" width={'97%'} height={300} />
            ))}
          </Carousel>
        ) : (
          <Carousel responsive={responsive} keyBoardControl={true}>
            {doubleproductlist1}
          </Carousel>
        )}
        <div id="ourCollection-bottom" style={{ height: "1px" }}></div>
        {loadingMore}
        {/* {loadingMore && <p>Loading more products...</p>} */}

        <br/>
        {/* <Carousel responsive={responsive} keyBoardControl={true}>
          {doubleproductlist2}
        </Carousel> */}

      </div>
      
      </>
  )
}
